import { InjectionToken } from '@angular/core';
import { CurrencyMaskConfig } from '@fleet/model';

export let CURRENCY_MASK_CONFIG = new InjectionToken<CurrencyMaskConfig>(
  'currency.mask.config'
);
